import { Action } from "redux";
import { IWorkflowItem, IWorkflowItemStep } from "../../../common/sharedTypes";

// ACTIONS
export interface IKeywordQueueAction extends Action {
  type: "@@keywordqueue/GET_KEYWORD_QUEUE_REPORTS";
  payload: {};
}

export enum KeywordActionTypes {
  SEARCH_KEYWORDS = "@@keywordqueue/GET_KEYWORD_QUEUE_REPORTS",
  SEARCH_KEYWORDS_ITEMS = "@@keywordqueue/GET_KEYWORD_QUEUE_ITEMS",
  SEARCH_KEYWORDS_TOTAL = "@@keywordqueue/GET_KEYWORD_QUEUE_ITEMS_TOTAL",
  LOADING_KEYWORD_ITEMS = "@@keywordqueue/LOADING_KEYWORD_ITEMS",
  OPEN_REPORT = "@@keywordqueue/OPEN_REPORT",
  ASSIGN_AND_OPEN_REPORT = "@@keywordqueue/ASSIGN_AND_OPEN_REPORT",
  UNASSIGN = "@@keywordqueue/UNASSIGN",
  COMPLETE_DATA_ENTRY = "@@keywordqueue/COMPLETE_DATA_ENTRY",
  UPDATE_WORKFLOW_ITEM_STEP = "@@keywordqueue/UPDATE_WORKFLOW_ITEM_STEP",
  SAVE_KEYWORDS = "@@keywordqueue/SAVE_KEYWORDS",
  LOAD_KEYWORDS_INTO_STORE = "@@keywordqueue/LOAD_KEYWORDS_INTO_STORE",
  LOAD_COUNTIES_INTO_STORE = "@@keywordqueue/LOAD_COUNTIES_INTO_STORE",
  LOAD_REPORT_TYPES_INTO_STORE = "@@keywordqueue/LOAD_REPORT_TYPES_INTO_STORE",
  LOAD_IMAGE = "@@keywordqueue/LOAD_IMAGE",
  LOAD_REPORT_MATCHES = "@@keywordqueue/LOAD_REPORT_MATCHES",
  STATUS_CHANGE = "@@keywordqueue/STATUS_CHANGE",
  GET_IMAGE = "@@keywordqueue/GET_IMAGE",
}

export type QNotificationActions = IKeywordQueueAction;
